import { MigrationReportStatus } from 'types';

export const REPORTS_POLL_INTERVAL_MS = 5000;
export const REPORTS_LIMIT = 50;

export const ACTIVE_STATUSES: MigrationReportStatus[] = ['pending', 'running'];

export const STATUS_COLORS: Record<MigrationReportStatus, string> = {
  pending: '#9e9e9e',
  running: '#1976d2',
  finished: '#2e7d32',
  failed: '#d32f2f',
};
